/* eslint-disable no-unused-vars */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import ClientContact from '../../organisms/ClientContact';
import ItemSelect from '../../organisms/ItemSelect';
import SubmitButton from '../../../../components/atoms/SubmitButton';
import ContentSpacer from '../../../../components/atoms/ContentSpacer';
import ReleaseOfInformation from '../../organisms/ReleaseOfInformation';

const StyledSubmit = styled(SubmitButton)`
  margin-top: 32px;
`;

const StyledAlert = styled(Alert)`
  margin-top: 32px;
`;

const CreateBundleTemplate = (props) => {
  const {
    contact,
    setContact,
    setVerbalRoiContact,
    setRoiContact,
    assessmentSelect,
    documentSelect,
    formSelect,
    roiSelect,
    handleClick,
    hasDocumentAssigned,
    disabled,
    wasSuccess,
    wasFailure,
    error,
    roiContacts,
    verbalRoiContacts,
  } = props;

  return (
    <Container>
      {assessmentSelect.itemList.length > 0 && (
        <ItemSelect
          sectionName={assessmentSelect.sectionName}
          groupName={assessmentSelect.groupName}
          type={assessmentSelect.type}
          itemList={assessmentSelect.itemList}
          onChange={assessmentSelect.onChange}
          disabled={disabled || assessmentSelect.disabled}
        />
      )}
      {documentSelect.itemList.length > 0 && (
        <ItemSelect
          sectionName={documentSelect.sectionName}
          groupName={documentSelect.groupName}
          type={documentSelect.type}
          itemList={documentSelect.itemList}
          onChange={documentSelect.onChange}
          disabled={disabled || documentSelect.disabled}
        />
      )}
      <ReleaseOfInformation
        itemList={roiSelect.itemList}
        verbalRoiContacts={verbalRoiContacts}
        roiContacts={roiContacts}
        setVerbalRoiContact={setVerbalRoiContact}
        setRoiContact={setRoiContact}
        disabled={disabled}
        onChange={roiSelect.onChange}
      />
      {formSelect.itemList.length > 0 && (
      <ItemSelect
        sectionName={formSelect.sectionName}
        groupName={formSelect.groupName}
        type={formSelect.type}
        itemList={formSelect.itemList}
        onChange={formSelect.onChange}
        disabled={disabled || formSelect.disabled}
      />
      )}
      <ClientContact
        contact={contact}
        setContact={setContact}
        disabled={disabled}
        hasDocumentAssigned={hasDocumentAssigned}
      />
      <ContentSpacer>
        <StyledSubmit
          label="Create Bundle"
          onClick={handleClick}
          disabled={disabled}
        />
      </ContentSpacer>
      <ContentSpacer>
        {wasSuccess && (
        <StyledAlert key="wasSuccess" variant="success">
          Form bundle successfully sent
        </StyledAlert>
        )}
        {wasFailure && (
        <StyledAlert key="wasFailure" variant="danger">
          {error}
        </StyledAlert>
        )}
      </ContentSpacer>
    </Container>
  );
};

CreateBundleTemplate.propTypes = {
  contact: PropTypes.shape({
    email: PropTypes.string,
    phone: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    contactPreference: PropTypes.string,
  }).isRequired,
  setContact: PropTypes.func.isRequired,
  setVerbalRoiContact: PropTypes.func.isRequired,
  setRoiContact: PropTypes.func.isRequired,
  assessmentSelect: PropTypes.shape({
    sectionName: PropTypes.string,
    groupName: PropTypes.string,
    type: PropTypes.oneOf(['checkbox', 'radio', 'switch']),
    itemList: PropTypes.arrayOf(PropTypes.object).isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
  }).isRequired,
  documentSelect: PropTypes.shape({
    sectionName: PropTypes.string,
    groupName: PropTypes.string,
    type: PropTypes.oneOf(['checkbox', 'radio', 'switch']),
    itemList: PropTypes.arrayOf(PropTypes.object).isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
  }).isRequired,
  formSelect: PropTypes.shape({
    sectionName: PropTypes.string,
    groupName: PropTypes.string,
    type: PropTypes.oneOf(['checkbox', 'radio', 'switch']),
    itemList: PropTypes.arrayOf(PropTypes.object).isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
  }).isRequired,
  roiSelect: PropTypes.shape({
    sectionName: PropTypes.string,
    groupName: PropTypes.string,
    type: PropTypes.oneOf(['checkbox', 'radio', 'switch']),
    itemList: PropTypes.arrayOf(PropTypes.object).isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
  }).isRequired,
  handleClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hasDocumentAssigned: PropTypes.bool.isRequired,
  wasSuccess: PropTypes.bool.isRequired,
  wasFailure: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
  verbalRoiContacts: PropTypes.arrayOf(PropTypes.shape({
    clientVisitId: PropTypes.number.isRequired,
    contact: PropTypes.string.isRequired,
  })),
  roiContacts: PropTypes.arrayOf(PropTypes.shape({
    clientVisitId: PropTypes.number.isRequired,
    contact: PropTypes.string.isRequired,
  })),
};

CreateBundleTemplate.defaultProps = {
  disabled: false,
  verbalRoiContacts: [],
  roiContacts: [],
};

export default CreateBundleTemplate;
